<template>
  <div
    id="class"
    class="relative flex flex-col justify-center items-center w-full bg-class-section bg-no-repeat bg-cover py-16 overflow-hidden"
  >
    <section-title titlePath="title-3.png" />
    <div class="btns flex flex-row justify-center w-full">
      <div
        v-for="(menu, index) in menuData"
        :key="index"
        :class="{ menuActive: menu.isActive }"
        class="cursor-pointer w-158 h-54 m-3 text-white font-elmessiri text-xl flex justify-center items-center bg-cover bg-center bg-btn-off"
        @click="handleMenu(index)"
      >
        {{ menu.text }}
      </div>
    </div>
    <transition-group name="fade" tag="div" class="relative w-full h-300">
      <!-- main class -->
      <div
        v-show="menuData[0].isActive"
        class="absolute w-full flex"
        :key="menuData[0].text"
      >
        <div class="box-border block w-0 min-w-full">
          <VueSlickCarousel
            v-bind="settings"
            class="class-carousel"
            ref="classCarousel"
          >
            <div
              class="card-wrapper"
              v-for="(slideClass, index) in mainClassData"
              :key="index"
              @click="openSlider(slideClass.number)"
            >
              <div class="relative mx-1 mt-16">
                <div class="dark-layout"></div>
                <img class="mx-auto" :src="`${imgPath}${slideClass.face}`" />
              </div>
            </div>
            <template #prevArrow="arrowOption">
              <div
                class="bg-prev-arrow bg-center bg-cover w-24 h-24 cursor-pointer m-auto z-20 absolute top-1/2 left-0.5/10 transform translate-x-0 -translate-y-1/2 xl:left-0"
              ></div>
            </template>
            <template #nextArrow="arrowOption">
              <div
                class="bg-next-arrow bg-center bg-cover w-24 h-24 cursor-pointer m-auto z-20 absolute top-1/2 right-0.5/10 transform translate-x-0 -translate-y-1/2 xl:right-0"
              ></div>
            </template>
          </VueSlickCarousel>
        </div>
      </div>

      <!-- sub class -->
      <div
        v-show="menuData[1].isActive"
        class="absolute w-full flex"
        :key="menuData[1].text"
      >
        <div class="box-border block w-0 min-w-full">
          <VueSlickCarousel
            v-bind="settings"
            class="class-carousel"
            ref="classCarousel"
          >
            <div
              class="card-wrapper"
              v-for="(slideClass, index) in subClassData"
              :key="index"
              @click="openSlider(slideClass.number)"
            >
              <div class="relative mx-1 mt-16">
                <div class="dark-layout"></div>
                <img class="mx-auto" :src="`${imgPath}${slideClass.face}`" />
              </div>
            </div>
            <template #prevArrow="arrowOption">
              <div
                class="bg-prev-arrow bg-center bg-cover w-24 h-24 cursor-pointer m-auto z-20 absolute top-1/2 left-0.5/10 transform translate-x-0 -translate-y-1/2 xl:left-0"
              ></div>
            </template>
            <template #nextArrow="arrowOption">
              <div
                class="bg-next-arrow bg-center bg-cover w-24 h-24 cursor-pointer m-auto z-20 absolute top-1/2 right-0.5/10 transform translate-x-0 -translate-y-1/2 xl:right-0"
              ></div>
            </template>
          </VueSlickCarousel>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SectionTitle from '../components/SectionTitle/SectionTitle.vue';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
export default {
  components: { SectionTitle, VueSlickCarousel },
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
      settings: {
        arrows: true,
        dots: false,
        autoplay: false,
        centerMode: true,
        centerPadding: '60px',
        focusOnSelect: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        adaptiveHeight: true,
      },
      mainClassData: [
        {
          face: '/slide4/Main/main_card1.png',
          number: 0,
          classes: [
            {
              id: 0,
              icon: '/slide4/Icons/ico_main1_1.png',
              title: 'Hero',
            },
            {
              id: 1,
              icon: '/slide4/Icons/ico_main1_2.png',
              title: 'Blade Master',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card2.png',
          number: 2,
          classes: [
            {
              id: 2,
              icon: '/slide4/Icons/ico_main2_1.png',
              title: 'Savior',
            },
            {
              id: 3,
              icon: '/slide4/Icons/ico_main2_2.png',
              title: 'sefirot',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card3.png',
          number: 4,
          classes: [
            {
              id: 4,
              icon: '/slide4/Icons/ico_main3_1.png',
              title: 'Archmage',
            },
            {
              id: 5,
              icon: '/slide4/Icons/ico_main3_2.png',
              title: 'Pop Star',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card4.png',
          number: 6,
          classes: [
            {
              id: 6,
              icon: '/slide4/Icons/ico_main4_1.png',
              title: 'Wind Stalker',
            },
            {
              id: 7,
              icon: '/slide4/Icons/ico_main4_2.png',
              title: 'Der Freischütz',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card5.png',
          number: 7,
          classes: [
            {
              id: 8,
              icon: '/slide4/Icons/ico_main5.png',
              title: 'Swordian',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card6.png',
          number: 9,
          classes: [
            {
              id: 9,
              icon: '/slide4/Icons/ico_main6.png',
              title: 'Souless One',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card7.png',
          number: 10,
          classes: [
            {
              id: 10,
              icon: '/slide4/Icons/ico_main7_1.png',
              title: 'Arc Master',
            },
            {
              id: 11,
              icon: '/slide4/Icons/ico_main7_2.png',
              title: 'Force Master',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card8.png',
          number: 12,
          classes: [
            {
              id: 12,
              icon: '/slide4/Icons/ico_main8.png',
              title: 'Black Anima',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card9.png',
          number: 13,
          classes: [
            {
              id: 13,
              icon: '/slide4/Icons/ico_main9.png',
              title: 'Demigod',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card10.png',
          number: 14,
          classes: [
            {
              id: 14,
              icon: '/slide4/Icons/ico_main10.png',
              title: 'Agni',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card11.png',
          number: 15,
          classes: [
            {
              id: 15,
              icon: '/slide4/Icons/ico_main11.png',
              title: 'Dark Chaser',
            },
          ],
        },
        {
          face: '/slide4/Main/main_card12.png',
          number: 16,
          classes: [
            {
              id: 16,
              icon: '/slide4/Icons/ico_main12.png',
              title: 'Shadow Walker',
            },
          ],
        },
      ],
      // Sub class
      subClassData: [
        {
          face: '/slide4/Sub/sub_card1.png',
          number: 0,
          classes: [
            {
              id: 0,
              icon: '/slide4/Icons/ico_sub1.png',
              title: 'HighLander',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card2.png',
          number: 1,
          classes: [
            {
              id: 1,
              icon: '/slide4/Icons/ico_sub2.png',
              title: 'Sword Dancer',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card3.png',
          number: 2,
          classes: [
            {
              id: 2,
              icon: '/slide4/Icons/ico_sub3.png',
              title: 'Terror Knight',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card4.png',
          number: 3,
          classes: [
            {
              id: 3,
              icon: '/slide4/Icons/ico_sub4.png',
              title: 'Psykicker',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card5.png',
          number: 4,
          classes: [
            {
              id: 4,
              icon: '/slide4/Icons/ico_sub5.png',
              title: 'Phantom Mage',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card6.png',
          number: 5,
          classes: [
            {
              id: 5,
              icon: '/slide4/Icons/ico_sub6.png',
              title: 'Maestro',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card7.png',
          number: 6,
          classes: [
            {
              id: 6,
              icon: '/slide4/Icons/ico_sub7.png',
              title: 'Rogue Master',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card8.png',
          number: 7,
          classes: [
            {
              id: 7,
              icon: '/slide4/Icons/ico_sub8.png',
              title: 'Judgment',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card9.png',
          number: 8,
          classes: [
            {
              id: 8,
              icon: '/slide4/Icons/ico_sub9.png',
              title: 'Star Seeker',
            },
          ],
        },
        {
          face: '/slide4/Sub/sub_card10.png',
          number: 9,
          classes: [
            {
              id: 9,
              icon: '/slide4/Icons/ico_sub10.png',
              title: 'Jewel Star',
            },
          ],
        },
      ],
    };
  },
  methods: {
    handleMenu: function(menuIndex) {
      this.$store.commit('CLASS_SECTION/HANDLE_MENU', menuIndex);
    },
    openSlider: function(id) {
      //console.log(id);
      this.$store.commit('CLASS_SECTION/OPEN_WINDOW', id);
    },
  },
  computed: {
    ...mapState({
      menuData: state => state.ClassSection.menuData,
    }),
  },
};
</script>

<style lang="postcss" scoped>
.btns .menuActive {
  @apply bg-btn-on;
}
.class-carousel >>> .slick-list {
  @apply overflow-x-hidden !important;
  height: 300px;
}
.class-carousel >>> .slick-list .slick-track .slick-slide {
  @apply relative w-183;
  height: 300px;
}
.slick-slide .dark-layout {
  @apply absolute w-full max-w-300 h-full left-0 top-0 bg-black bg-opacity-70;
}
.slick-active .dark-layout {
  @apply absolute w-full h-full left-0 top-0 bg-transparent bg-opacity-100;
}
.slick-slide .card-wrapper {
  @apply absolute transition transform translate-y-0 duration-100 ease-in;
}
.slick-active .card-wrapper {
  @apply transition transform -translate-y-5 duration-500 ease-out;
}
</style>
